
<h2 class="pl-6 font-bold text-xl">{{ 'media_library.cc.preview.title' | translate }}</h2>

<mat-dialog-content>
  @if (data.originalAssetName) {
    <div class="asset-name">
      <mat-icon>closed_caption</mat-icon>
      <span>{{ data.originalAssetName }}</span>
    </div>
  }

  <div class="video-wrapper">
    <video
      [src]="videoUrl"
      controls
      preload="metadata"
      class="preview-video">
    </video>
  </div>

  <p class="hint">{{ 'media_library.cc.preview.hint' | translate }}</p>
</mat-dialog-content>

<div class="p-4 flex justify-between">
  <cm-ui-standard-button roundedGray  (click)="discard()" [disabled]="saving()">
    {{ 'media_library.cc.preview.discard' | translate }}
  </cm-ui-standard-button>
  <cm-ui-standard-button
    rounded green  
    icon="save"
    [disabled]="saving()"
    (click)="save()">
    @if (saving()) {
      <mat-progress-spinner diameter="16" mode="indeterminate" />
    }
    {{ 'media_library.cc.preview.save' | translate }}
  </cm-ui-standard-button>
</div>
